<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      isShowIndex: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      filteringProfanity: (state) => state.presentation.filteringProfanity,
    }),
    leaderboardSlides() {
      if (!this.presentation || !this.presentation.slides) {
        return null
      }
      return this.presentation.slides.filter((item) => {
        return item.type === 'leaderboard'
      })
    },
    leaderboardIds() {
      if (!this.leaderboardSlides) return null
      return this.leaderboardSlides.map((item) => item.id)
    },
    isFirstLeaderboard() {
      if (!this.leaderboardSlides || this.leaderboardSlides.length === 0) {
        return false
      }
      const firstLeaderboardId = this.leaderboardIds[0]
      return this.slideActive.id === firstLeaderboardId
    },
    isNextLeaderboard() {
      if (!this.$store.state.lastViewLeaderboardId) return false
      const currentLeaderboardId = this.slideActive.id

      const currentLeaderboardIndex = this.leaderboardIds.indexOf(currentLeaderboardId)
      const lastLeaderboardIndex = this.leaderboardIds.indexOf(
        this.$store.state.lastViewLeaderboardId,
      )

      return currentLeaderboardIndex > lastLeaderboardIndex
    },
    isAudienceRankVisible() {
      return this.isFirstLeaderboard || this.isShowIndex || !this.isNextLeaderboard
    },
  },
  methods: {
    ...mapActions([
      'checkSlideMovingDirectionAction',
    ]),
  },
}
</script>

<style lang="scss">
.leaderboard-move {
  transition: transform 0.5s;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
